export default __webpack_public_path__ + "static/media/metabric.c76265c5.csv";